import { render, staticRenderFns } from "./_CriticalIllness.vue?vue&type=template&id=8e9fff8a&"
import script from "./_CriticalIllness.vue?vue&type=script&lang=js&"
export * from "./_CriticalIllness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports